import { render, staticRenderFns } from "./TagsEditor.vue?vue&type=template&id=68dee363"
import script from "./TagsEditor.vue?vue&type=script&lang=ts"
export * from "./TagsEditor.vue?vue&type=script&lang=ts"
import style0 from "./TagsEditor.vue?vue&type=style&index=0&id=68dee363&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports